module.exports = __webpack_public_path__ + "img/public-record.d0289dc0.png";